import { DEFAULT_SORT_CONFIG } from '@/components/FilterManager/SortMenu/utils';
import { FilterState, SortEnums } from '@/components/FilterManager/types';
import { SortState } from '@/components/FilterManager/types';
import { DiscoverPageFacetFragment } from '@/modules/corporate/modules/discover/views/Discover/graphql/fragments/generated/DiscoverPageFacet';
import { MOST_ACCESSED_ID } from '@/modules/corporate/modules/search/views/SearchResults/utils';
import { FacetTypeEnum, FacetValueInput, Maybe, OrderEnum } from '@/types/schema';

import { DefaultCategoryId } from '../../components/CategorySidebar/conts';
import { isDefaultCategory } from '../../components/CategorySidebar/utils';

type SortItem = {
  field: string;
  order: OrderEnum;
};

interface DefaultValues {
  defaultFilters: FilterState;
  defaultSearch: string;
  defaultSortBy: SortState;
}

interface GetFacetValueInputsParams {
  filter: FilterState;
  sort: SortItem[];
  search: string;
  searchFacetId?: string;
  sortFacetId?: string;
}

export const getFacetDefaultValues = (facetConfig?: Maybe<DiscoverPageFacetFragment>) => {
  const defaults: DefaultValues = { defaultFilters: {}, defaultSortBy: [], defaultSearch: '' };

  if (facetConfig?.searchFacet?.defaultValues?.[0]) {
    defaults.defaultSearch = facetConfig.searchFacet.defaultValues[0];
  }

  if (facetConfig?.sortFacet?.defaultValues?.[0]) {
    const { defaultValues } = facetConfig.sortFacet; // Later on it will be handled with facetConfig
    defaults.defaultSortBy = DEFAULT_SORT_CONFIG.NEWEST;
  }

  facetConfig?.filterFacets?.forEach(({ id, type, defaultValues }) => {
    if (defaultValues?.length) {
      defaults.defaultFilters[id] =
        type === FacetTypeEnum.MultiSelect ? defaultValues : defaultValues[0];
    }
  });

  return defaults;
};

export const getFacetValueInputs = ({
  filter,
  search,
  searchFacetId,
  sort,
  sortFacetId,
}: GetFacetValueInputsParams): FacetValueInput[] => {
  const facetValueInputs: FacetValueInput[] = [];

  if (searchFacetId) {
    if (search) facetValueInputs.push({ id: searchFacetId, values: [search] });
  }

  if (sortFacetId) {
    const value = sort[0]?.field;
    if (value) facetValueInputs.push({ id: sortFacetId, values: [value] });
  }

  Object.entries(filter).forEach(([id, value]) => {
    if (value) {
      if (typeof value === 'string') {
        facetValueInputs.push({ id, values: [value] });
      } else if (Array.isArray(value)) {
        facetValueInputs.push({ id, values: value as string[] });
      }
    }
  });

  return facetValueInputs;
};

export const getCategoryDefaultSort = (categoryId?: string): SortState => {
  if (!isDefaultCategory(categoryId)) {
    return [];
  }

  switch (categoryId as DefaultCategoryId) {
    case DefaultCategoryId.POPULAR_CONTENT:
      return [{ field: MOST_ACCESSED_ID, order: OrderEnum.Desc }];
    case DefaultCategoryId.NEW_CONTENT:
      return DEFAULT_SORT_CONFIG[SortEnums.Newest];
    default:
      return [];
  }
};
